/** Uploade une image et renvoie son URL servable. Throw avec le message backend en cas d'échec. */
export async function uploadImage(clientId: number, file: File): Promise<string> {
  const body = new FormData()
  body.append('file', file)
  // Pas de Content-Type explicite : le navigateur pose lui-même le boundary multipart.
  const res = await fetch(`/api/uploads/clients/${clientId}/images`, {
    method: 'POST',
    body,
    credentials: 'include',
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || 'Upload impossible')
  return json.data.url as string
}

/**
 * Valeurs distinctes d'une dimension, pour l'autocomplétion des filtres.
 * Un échec ne doit JAMAIS casser le drawer : on renvoie une liste vide
 * et l'utilisateur saisit sa valeur à la main.
 */
export async function fetchDimensionValues(
  dataSourceId: string,
  dimension: string,
  period?: { start?: string; end?: string }
): Promise<string[]> {
  try {
    const qs = new URLSearchParams({ data_source_id: dataSourceId, dimension })
    if (period?.start) qs.set('start', period.start)
    if (period?.end) qs.set('end', period.end)
    const res = await fetch(`/api/query/dimension-values?${qs}`, { credentials: 'include' })
    if (!res.ok) return []
    const json = await res.json()
    return Array.isArray(json.data) ? json.data : []
  } catch {
    return []
  }
}
